export const removeBodyScroll = () => {
  document.body.classList.add('vv-modal-open');
};

export const addBodyScroll = () => {
  document.body.classList.remove('vv-modal-open');
};
